const TENANT_STORAGE_KEY = 'tenant_slug'

// Subdomains that are NOT tenants - they are application-level routes.
// When the host is one of these, the slug field stays editable so any
// provisioned tenant can log in.
const RESERVED_SUBDOMAINS = new Set([
  'app', 'www', 'api', 'admin', 'staging', 'stage', 'dev', 'test',
  'preview', 'demo', 'beta', 'mail', 'cdn', 'static', 'assets',
])

export function getTenantSlugFromHost(hostname: string): string | null {
  if (!hostname) return null
  const host = hostname.toLowerCase()
  if (host === 'localhost' || host === '127.0.0.1' || host === '[::1]') {
    return null
  }
  const parts = host.split('.').filter(Boolean)
  if (parts.length >= 3) {
    const candidate = parts[0]
    if (RESERVED_SUBDOMAINS.has(candidate)) return null
    return candidate
  }
  if (parts.length >= 2 && parts[parts.length - 1] === 'localhost') {
    const candidate = parts[0]
    if (RESERVED_SUBDOMAINS.has(candidate)) return null
    return candidate
  }
  return null
}

export function resolveTenantSlug(): string | null {
  if (typeof window === 'undefined') return null
  const envSlug = import.meta.env.VITE_TENANT_SLUG
  if (envSlug && typeof envSlug === 'string' && envSlug.trim()) {
    return envSlug.trim()
  }
  const hostSlug = getTenantSlugFromHost(window.location.hostname)
  if (hostSlug) return hostSlug
  const stored = window.localStorage.getItem(TENANT_STORAGE_KEY)
  if (stored && stored.trim()) return stored.trim()
  return null
}

export function storeTenantSlug(slug: string): void {
  if (typeof window === 'undefined') return
  if (!slug) return
  window.localStorage.setItem(TENANT_STORAGE_KEY, slug)
}
